import React, {createContext, useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {ROUTE_PREFIX, ROUTES} from "./helpers/RoutingHelpers";

const ModuleContext = createContext();

export function useModuleContext() {
  return useContext(ModuleContext);
}

export function ModuleProvider({ children }) {
  const history = useHistory();

  /* Add to proposal Modal */
  const [proposalModalShow, setProposalModalShow] = useState(false);
  const [idForProposal, setIdForProposal] = useState(false);
  const proposalModalProps = {
    proposalModalShow, idForProposal,
    openProposalDialog: id=> { setIdForProposal(id); setProposalModalShow(true); },
    closeProposalDialog: ()=> { setIdForProposal(null); setProposalModalShow(false); },
  }

  /* Submit Hire Modal */
  const [hireModalShow, setHireModalShow] = useState(false);
  const [idForHire, setIdForHire] = useState(false);
  const hireModalProps = {
    hireModalShow, idForHire,
    openHireDialog: id=> { setIdForHire(id); setHireModalShow(true); },
    closeHireDialog: ()=> { setIdForHire(null); setHireModalShow(false); },
  }


  const getDetailsPath = id =>`${ROUTE_PREFIX}/${id}`
  const value = {
    ...proposalModalProps,
    ...hireModalProps,
    newButtonClick: ()=> { history.push(ROUTES.new.path); },
    savedClick: ()=> { history.push(ROUTES.saved.path); },
    listClick: ()=> { history.push(ROUTES.list.path); },
    openEditPage: (id)=> { history.push(`${ROUTE_PREFIX}/${id}/edit`); },
    openDetailsPage: (id) => { history.push(getDetailsPath(id)); },
    getDetailsPath
  };

  return (
    <ModuleContext.Provider value={value}>
      {children}
    </ModuleContext.Provider>
  );
}
